module.exports = __webpack_public_path__ + "r-v3/img/screen_decrease_white.216be77a.svg";